// @flow
import { Map } from "immutable";

export const allTaxesSelector = (state: Map<string, any>) => {
  return state.getIn(["tax", "taxes"])
}
export const taxErrorSelector = (state: Map<string, any>) => {
  return state.getIn(["tax", "error"])
}


// WEBPACK FOOTER //
// ./src/features/tax/store/taxSelectors.js